export const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]:\[(?<=\[).+?(?=\])\]?)|(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
export const urlRegexLink = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
export const tagRegex = /(tag:|t:).*?[^<]*/ig
export const linktextRegex = /(?<=\[).+?(?=\])/ig

const sleep = duration => new Promise(resolve => setTimeout(resolve, duration))
export const poll = (promiseFn, duration) => promiseFn().then(
             sleep(duration).then(() => poll(promiseFn, duration)))


export const urlify = (text) => {
  return text.replace(urlRegex, (url) => {

    if (url.includes('youtu')) {
      const ytid = getYouTubeVideoIdFromUrl(url)
      return `<lite-youtube videoid="${ytid}" playlabel="Play"></lite-youtube>`
    }

    if (url.includes(':img')) {
      const imgUrl = url.replace(':img', '')
      return `<img src=${imgUrl} alt="picture" />`
    }

    if (url.includes(':[')) {
      const text = url.match(linktextRegex)
      const link = url.match(urlRegexLink)
      return `<a href="${link}" target="_blank">${text}</a>`
    }

    if (url.includes('bandcamp') || url.includes('cloudapp')) {
      return url
    }

    return `<a href="${url}" target="_blank">${url}</a>`
  })
  // or alternatively
  // return text.replace(urlRegex, '<a href="$1">$1</a>')
}

export const tagify = (text) => {
  return text.replace(tagRegex, tagged => {
    if (tagged.includes('bandcamp')) {
      return tagged
    }

    const tags = tagged.split(' ').filter(t => t)
    const allTags = tags.map(t => {
      const tag = t.split(':').pop()
      return `<a href="/tag/#${tag}">#${tag}</a> `
    })

    return allTags.join(' ')
  })
}


const getYouTubeVideoIdFromUrl = (url) => {
  // Our regex pattern to look for a youTube ID
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  //Match the url with the regex
  const match = url.match(regExp)
  //Return the result
  return match && match[2].length === 11 ? match[2] : undefined
}

export const formatCodeSnippet = text => {
  const snippetRegex = /<code>(.+?)<\/code>/gs

  return text.replace(snippetRegex, snippet => {
    return `<code>${snippet}</code>`
  })
}

export const intersectionObserver = fetchFn => new IntersectionObserver(entries => {
  if (entries[0].intersectionRatio <= 0) return
  fetchFn()
});


const daysOfTheWeek = {
  0: 'Sunday',
  1: "Monday",
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}
const months = Array.from({length: 12}, (e, i) => {
   return new Date(null, i + 1, null).toLocaleDateString("en", {month: "long"});
})

export const formatDate = (fullDate) => {
  if (fullDate === 'Just now') return fullDate
  const d = new Date(fullDate)
  return `${daysOfTheWeek[d.getDay()]} ${d.getDate()} of ${months[d.getMonth()]}, ${d.getFullYear()}`
}


export const toolbarOptions = [
  [{ 'header': [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
  // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
  // [{ 'direction': 'rtl' }],                         // text direction

  // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  // [{ 'font': [] }],
  [{ 'align': [] }],
  ['clean'],                                         // remove formatting button
]
